import styled from 'styled-components';

const InventoryStyledComponent = styled.div`
  .edit-quantity-cell {
    display: flex;
  }
`;

export default InventoryStyledComponent;
